import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useBrandsVisivibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteBrandSelect
  }), [permissions]);
};
